import React from 'react';
import { Table } from 'react-bootstrap';
import Utils from '../../../../Utils';

const CpcTable = ({ countries, cpc}) => {
    const sources = Object.keys(cpc);
    const { heading, subHeading } = sources.reduce(({ heading, subHeading }, source, index) => {
        heading.push(<th colSpan={2} key={source}>{source}</th>);

        subHeading.push(<th key={`pc-${index}`}>PC</th>);
        subHeading.push(<th key={`mobile-${index}`}>Mobile</th>);

        return { heading, subHeading };
    }, { heading: [], subHeading: [] });

    const cpcRows = countries.map(country => {
        const valuesTd = sources.reduce((arr, source) => {
            const sourceCpc = cpc[source];
            let pcValue = sourceCpc[country] && sourceCpc[country].pc ? Utils.roundTo2Decimal(sourceCpc[country].pc) : 'NA';
            let mobileValue = sourceCpc[country] && sourceCpc[country].mobile ? Utils.roundTo2Decimal(sourceCpc[country].mobile) : 'NA';

            arr.push(<td key={`pc-${source}-${pcValue}`}>{pcValue}</td>);
            arr.push(<td key={`mobile-${source}-${mobileValue}`}>{mobileValue}</td>);

            return arr;
        }, []);


        return (
            <tr key={country}>
                <td>{country}</td>
                {valuesTd}
            </tr>
        );
    });

    return (
        <Table bordered responsive>
            <thead>
                <tr>
                    <th rowSpan={2}></th>
                    {heading}
                </tr>
                <tr>
                    {subHeading}
                </tr>
            </thead>
            <tbody>
                {cpcRows}
            </tbody>
        </Table>
    );
};

export default CpcTable;


// WEBPACK FOOTER //
// ./src/scenes/BidderCpc/components/CpcTable/index.js